import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { SubscriptionsDataService, SubscriptionsColumnsService } from '../../../services';
import { Subscription, SubscriptionsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class SubscriptionDetailsComponent implements OnInit, OnDestroy {

  public subscription: Subscription = {};
  public subscriptions: Subscription[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private subscriptionsDataService: SubscriptionsDataService,
    private subscriptionsColumnsService: SubscriptionsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Subscription - Details');
        this.getSubscription(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.subscription !== 'undefined') {
      this.subscription = this.dynamicDialogConfig.data.subscription;
    }
    this.columns = this.subscriptionsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getSubscription(id: number): void {
    this.isLoading = true;
    this.subscriptionsDataService.getSubscription(id).subscribe((response: Subscription|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.subscription = response;
      }
    });
  }

  list() {
    this.router.navigate(['/subscriptions']);
  }

  add() {
    this.router.navigate(['/subscriptions/add']);
  }

  edit() {
    this.router.navigate(['/subscriptions/edit/' + this.subscription.id]);
  }

}
@Component({
  selector: 'app-subscription-details',
  templateUrl: './subscription-details.component.html',
  styleUrls: ['./subscription-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogSubscriptionDetailsComponent extends SubscriptionDetailsComponent {
}

